import { useTranslation } from 'next-i18next'
import React from 'react'
import AnimatedSection from 'src/components/AnimatedSection'
import Carousel from 'src/components/Carousel/ResponsiveCarousel'
import BaseButton from '../Buttons/BaseButton'
import Step, { ICard } from './Step'

interface IProps {
  title: string | React.ReactNode
  subtitle: string | React.ReactNode
  steps: ICard[]
  ctaHref?: string
  ctaClick?: () => void
  ctaText: string
  /** Legacy — retained for back-compat; editorial layout ignores it. */
  cardBgColor?: string
  ctaButtonWidth?: number
  /** Legacy — retained for back-compat; editorial layout ignores it. */
  noGradient?: boolean
  /** Stack the steps below md instead of the swipe carousel. */
  stackOnMobile?: boolean
}

const Steps = ({
  title,
  subtitle,
  steps,
  ctaText,
  ctaHref,
  ctaClick,
  ctaButtonWidth,
  stackOnMobile
}: IProps) => {
  const { t } = useTranslation('common')
  return (
    <AnimatedSection className="bg-white-500 py-20 md:py-28" variant="slideUp">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <div className="mb-14 max-w-3xl md:mb-20">
          <p className="font-display text-sm tracking-[0.2em] text-blue-500 uppercase">
            {t('PILLAR_SECTIONS.EYEBROW_HOW_IT_WORKS')}
          </p>
          <h2 className="mt-4 font-display text-4xl leading-[1.05] font-medium text-ink-700 md:text-5xl">
            {title}
          </h2>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-ink-200 md:text-lg">
            {subtitle}
          </p>
        </div>
        <Carousel
          items={steps}
          stackOnMobile={stackOnMobile}
          renderItem={(item, index) => (
            <div
              key={`step-${index}`}
              className="flex flex-col items-start justify-center"
            >
              <Step card={item} index={index} compact={stackOnMobile} />
            </div>
          )}
        />
        <div className="mt-12 md:mt-16">
          <BaseButton
            fontSize={14}
            width={ctaButtonWidth}
            size="medium"
            color="primary"
            variant="contained"
            rounded
            href={ctaHref}
            onClick={ctaClick}
          >
            {ctaText}
          </BaseButton>
        </div>
      </div>
    </AnimatedSection>
  )
}

export default Steps
